import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-navbar',
	template: require('./navbar.component.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent {
	@Input() brand: string;
	domain = this.capitalize(window.location.hostname.split('.')[0]);
	capitalize(input: string): string {
		return input.charAt(0).toUpperCase() + input.slice(1);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/core/navbar/navbar.component.ts